export default function getMileage(mileage) {
  if (+mileage === 0) {
    return 'Mileage not listed';
  }
  return `${mileage} miles`;
}
